import React, { useEffect } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import EditableDataGrid from 'components/EditableDataGrid/EditableDataGrid';
import Box from '@mui/material/Box';
import { useFetchData } from 'services/queries';

const TusRatesTab = ({ tableData, setTableData }) => {
    const resourcePath = 'tax/tus-rates';
    const relatedResources = 'tax/tus-rates';

    const { data: tusRates, isLoading: isLoadingTus, error: tusError } = useFetchData(resourcePath, true);
    useEffect(() => {
        if (tusRates) setTableData(tusRates);
    }, [tusRates, setTableData]);

    if (isLoadingTus) return <div>Loading...</div>;
    if (tusError) return <div>Error: {tusError.message}</div>;

    const tusColumns = [
        {
            field: 'additions',
            headerName: 'Number of Additions',
            type: 'number',
            flex: 1,
            editable: true,
            minWidth: 150,
            valueSetter: (value, row) => {
                const newValue = parseInt(value);
                if (isNaN(newValue) || newValue < 1) {
                    return row;
                }
                return { ...row, additions: newValue };
            }
        },
        {
            field: 'value',
            headerName: 'TUS Value (BRL)',
            type: 'number',
            flex: 1,
            editable: true,
            minWidth: 150,
            valueFormatter: (value) => {
                if (!value) return '';
                return new Intl.NumberFormat('pt-BR', {
                    style: 'currency',
                    currency: 'BRL'
                }).format(value);
            },
            valueSetter: (value, row) => {
                const newValue = parseFloat(value);
                if (isNaN(newValue) || newValue < 0) {
                    return row;
                }
                return { ...row, value: newValue };
            }
        }
    ];

    const newTusRateTemplate = {
        additions: 1,
        value: 0.00
    };

    return (
        <Card>
            <CardContent>
                <Box mb={2}>
                    <Typography variant="h5" gutterBottom>
                        TUS (Taxa Siscomex) Rates
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                        Manage the TUS rates based on number of additions
                    </Typography>
                </Box>
                <EditableDataGrid
                    tableData={tableData}
                    setTableData={setTableData}
                    resourcePath={resourcePath}
                    relatedResources={relatedResources}
                    columns={tusColumns}
                    newRowTemplate={newTusRateTemplate}
                    actions={{
                        create: true,
                        edit: true,
                        delete: true,
                        search: true
                    }}
                    initialState={{
                        pagination: { paginationModel: { pageSize: 10 } },
                        sorting: {
                            sortModel: [{ field: 'additions', sort: 'asc' }],
                        },
                    }}
                    autosizeOptions={{
                        includeOutliers: true,
                        includeHeaders: true,
                    }}
                    autosizeOnMount={true}
                />
            </CardContent>
        </Card>
    );
};

export default TusRatesTab;